import { FC } from "react";
import { useIntl } from "react-intl";
import { Box, Paper, Table, TableBody, TableContainer, Typography } from "@mui/material";

import { ProgressOverlay } from "@framework/mui-page-layout";
import { useAsu } from "@framework/provider-asu";

import { ITrainMechanism } from "../interfaces";
import { Row } from "./row";

export interface ITrainDetailsTable {
  details: ITrainMechanism[];
  loading: boolean;
}

export const TrainDetailsTable: FC<ITrainDetailsTable> = props => {
  const { details, loading } = props;
  const { isLoading } = useAsu();

  const { formatMessage } = useIntl();

  const noInfo = formatMessage({ id: "pages.scheme.trainScheme.details.infoNotFound" });

  return (
    <ProgressOverlay isLoading={loading || isLoading}>
      {details.length ? (
        <TableContainer
          component={Paper}
          elevation={0}
          sx={{ borderLeft: "1px solid #EBEBF7", borderTop: "1px solid #EBEBF7" }}
        >
          <Table aria-label="mechanisms">
            <TableBody>
              {details.map(row => (
                <Row key={row.id} row={row} />
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      ) : (
        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
          <Typography>{noInfo}</Typography>
        </Box>
      )}
    </ProgressOverlay>
  );
};
